import clsx, { ClassValue } from 'clsx'
import React from 'react'
import { IntlShape, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { IconSvg } from '../../atoms'
import {
  ClientProposalNudgeStateEnum,
  ClientProposalNudgeStateOutputDto,
} from '../../../lib/graphql'

const NUDGE_DATA = (
  intl: IntlShape,
): {
  [key in ClientProposalNudgeStateEnum]: {
    className: ClassValue
    icon: React.ReactNode
    getLabel: (value: number) => string
  }
} => ({
  [ClientProposalNudgeStateEnum.SIMULTANEOUS_OFFERS]: {
    className: s.nudgeBanner_red,
    icon: <IconSvg.Calendar color='var(--clr-red)' className={s.icon} />,
    getLabel: (value) =>
      intl.formatMessage(
        {
          id: 'ui.NudgeData.simultaneousOffers',
          defaultMessage:
            '{companiesNumber, plural, one {Une entreprise regarde} other {# entreprises regardent}} ce domaine aux mêmes dates',
        },
        { companiesNumber: value },
      ),
  },
  [ClientProposalNudgeStateEnum.OTHER_PROPOSALS]: {
    className: s.nudgeBanner_orange,
    icon: <IconSvg.IconEye color='var(--clr-orange)' className={s.icon} />,
    getLabel: (value) =>
      intl.formatMessage(
        {
          id: 'ui.NudgeData.otherProposals',
          defaultMessage:
            '{companiesNumber, plural, one {Une entreprise regarde} other {# entreprises regardent}} actuellement ce domaine',
        },
        { companiesNumber: value },
      ),
  },
})

export function NudgeBanner({
  nudgeState: { type, value },
  className: additionnalClassName,
}: {
  nudgeState: ClientProposalNudgeStateOutputDto
  className?: ClassValue
}) {
  const intl = useIntl()
  if (!value) {
    return null
  }

  const { className, icon, getLabel } = NUDGE_DATA(intl)[type]
  return (
    <div className={clsx(s.nudgeBanner, className, additionnalClassName)}>
      {icon} <span>{getLabel(value as number)}</span>
    </div>
  )
}
